import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import jianjie from '@/components/jianjie'
import search from '@/components/search'
import detail from '@/components/detail'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
			name:'Home',
      component: Home
    },
		{
			path:'/jianjie',
			name:'jianjie',
			component:jianjie
		},
		{
		  path: '/search',
			name:'search',
		  component: search
		},
		{
			path: '/detail',
			name:'detail',
			component: detail
		}
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js